// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8c3a515e","513":"56935067","703":"7868abb9","787":"1a5145ae"}[chunkId] + ".chunk.js";
};